export { InstantKnowledge } from './InstantKnowledge.component';
